var map = {
	"./Promotion-1.png": 8848,
	"./Promotion-2.png": 718,
	"./Promotion-3.png": 6471,
	"./X-TEXT.png": 6215,
	"./be-part.png": 4962,
	"./black-card.png": 6058,
	"./challenges-bg.png": 6381,
	"./challenges-title.png": 5463,
	"./clock.png": 2211,
	"./coins.png": 7096,
	"./combined-hero-section bg.png": 9243,
	"./comingsoon-text.png": 8930,
	"./dice.png": 7350,
	"./discord-icon.png": 942,
	"./discord.png": 1602,
	"./dummy.png": 447,
	"./hero-image.png": 8657,
	"./icon-bronze.png": 602,
	"./icon-gold.png": 4210,
	"./icon-silver.png": 467,
	"./instagram-icon.png": 302,
	"./instagram.png": 4794,
	"./kick-icon.png": 9605,
	"./kick.png": 7540,
	"./lead-reset.png": 3266,
	"./leaderboard-bg-grouped.png": 3564,
	"./leaderboard-title.png": 5726,
	"./linkstomysocials-text.png": 1885,
	"./merch-model.png": 6462,
	"./prev-lead-title.png": 2920,
	"./previous-leaderboard-bg.png": 3138,
	"./red-card.png": 5741,
	"./roobet-bg.png": 2206,
	"./roobet-button.png": 6440,
	"./roobet-herosection-text.png": 109,
	"./sample.svg": 6704,
	"./shirt-icon.png": 318,
	"./shop-icon.png": 8088,
	"./socials-bg.png": 5148,
	"./tag-icon.png": 6006,
	"./throphy.png": 8338,
	"./tiktok-icon.png": 23,
	"./tiktok.png": 9269,
	"./twitch-icon.png": 332,
	"./twitter-icon.png": 1294,
	"./twitter.png": 3220,
	"./use-code.png": 1664,
	"./viv.png": 8888,
	"./vivstream-bg.png": 9696,
	"./vivstream-link-text.png": 2851,
	"./vivstream-logo.png": 9923,
	"./vivstreamlogo-proposedlogo.png": 9689,
	"./youtube-icon.png": 9351,
	"./youtube.png": 9844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;